// PRD = /api/2.0
// DEV = http://envphp:8080/api/2.0
// CALL PRD = http://www.domain-name.com/api/2.0
const urlApi = "/api/2.0";

export { urlApi }